export default __webpack_public_path__ + "static/media/icn-lost.82e3d864.svg";